import React, { useState, useEffect, useCallback } from "react";
import Header from "../../commons/Header/Header";
import Sidebar from "../../commons/Sidebar/Sidebar";
import viewImage from "../../assets/images/icons/view.svg";
import TeamImg from "../../assets/images/login-bg.jpg";
import editImage from "../../assets/images/icons/edit-2.svg";
import DeleteIcon from "../../assets/images/icons/delete-w.svg";
import Cuisine from "../../assets/images/img.webp";
import { Link, useNavigate } from "react-router-dom";
import { handleApiCall } from "../../apis";
import { endpoints } from "../../utils/endpoints";
import { toast } from "react-toastify";
import { Button } from "react-bootstrap";
import TablePagination from "../../commons/Pagination/TablePagination";

function Ingrident() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);
  const [cms, setCms] = useState({ type: "publish" });
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit] = useState(5);
  const [totalPages, setTotalPages] = useState(1);

  const getList = useCallback(async () => {
    setLoading(true);
    try {
      const query = new URLSearchParams({
        page,
        limit,
        ...(search && { search }),
      }).toString();

      const response = await handleApiCall("get", `${endpoints.ingredientList}?${query}`);
      if (response?.data?.code === 200) {
        setData(response?.data?.data?.data || []);
        setTotalPages(response?.data?.data?.pagination?.totalPages || 1);
      }
    } catch (error) {
      console.error("Error fetching ingredients:", error);
      setError(true);
    } finally {
      setLoading(false);
    }
  }, [page, limit, search]);

  useEffect(() => {
    getList();
  }, [getList]);

  // Reset page to 1 when search changes
  useEffect(() => {
    setPage(1);
  }, [search]);

  const block = async (status, id) => {
    try {
      const response = await handleApiCall("patch", `${endpoints.ingredientStatusUpdate}/${id}`, {
        status,
      });
      if (response?.data?.code === 200) {
        toast.success(response?.data?.message || "Ingredient status updated!");
        getList();
      }
    } catch (error) {
      // Network errors are already handled by handleApiCall
    }
  };

  const deleteIngredient = async (id) => {
    if (window.confirm("Are you sure you want to delete this ingredient?")) {
      try {
        const response = await handleApiCall("delete", `${endpoints.ingredientDelete}/${id}`);
        if (response?.data?.code === 200) {
          toast.success("Ingredient deleted successfully!");
          getList();
        }
      } catch (error) {
        // Network errors are already handled by handleApiCall
      }
    }
  };

  return (
    <div className="container-scroller">
      <Header />
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="heading mb-3 d-flex align-items-center">
              <h3 className="text-default weight-400 my-0">Ingrident</h3>
            </div>
            <div className="mb-4 px-0 py-2">
              <div className="card-heading d-flex align-items-center mb-3 pb-2">
                <div className="d-flex align-items-center col-md-12 px-0">
                  <form className="col-md-3 px-0">
                    <div className="form-group my-0">
                      <input className="form-control search-icon left-icon border" placeholder="Search" value={search} onChange={(e) => setSearch(e.target.value)} />
                    </div>
                  </form>
                  <button onClick={() => navigate("/ingrident/add-ingrident")} className="ml-auto btn btn-primary">
                    Add New +
                  </button>
                </div>
              </div>
              <div className="col-md-12 tab-content row px-0 mx-0">
                <div className="table-responsive px-0">
                  <table className="table table-striped trim">
                    <thead>
                      <tr>
                        <th width="80" class="text-center">
                          ID
                        </th>
                        <th>Name</th>
                        <th width="150px">Status</th>
                        <th width="100px">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="4" className="text-center py-4">
                            <div className="spinner-border text-primary" role="status">
                              <span className="sr-only">Loading...</span>
                            </div>
                          </td>
                        </tr>
                      ) : data && data.length > 0 ? (
                        data.map((ingredient, index) => (
                          <tr key={ingredient._id}>
                            <td>{(page - 1) * limit + index + 1}</td>
                            <td className="text-center">{ingredient.name}</td>
                            <td>
                              <label className="custom-control custom-switch p-1 ml-4 mb-0 mt-1" role="button">
                                <input
                                  type="checkbox"
                                  className="custom-control-input"
                                  checked={ingredient.status === 1}
                                  onChange={() => block(ingredient.status === 1 ? 0 : 1, ingredient._id)}
                                />
                                <span className="custom-control-label custom-toggle" />
                              </label>
                            </td>
                            <td>
                              <button
                                onClick={() => {
                                  localStorage.setItem("selectedIngredient", JSON.stringify(ingredient));
                                  window.location.href = `/ingrident/edit-ingrident/${ingredient._id}`;
                                }}
                                className="btn btn-link p-0 mx-2"
                              >
                                <img src={editImage} alt="Edit" className="mr-2" />
                              </button>
                              {/* <button onClick={() => deleteIngredient(ingredient._id)} className="btn btn-link p-0 mx-2">
                                <img src={DeleteIcon} alt="Delete" className="mr-2" />
                              </button> */}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="4" className="text-center py-4">
                            No Data Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              <TablePagination page={page} totalPages={totalPages} onPageChange={setPage} />

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Ingrident;
